"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.chat.nomodel': 'Seleziona un modello per iniziare a chattare',
};
